import React, { useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { userIsLoggingIn } from "../../store/iam/selectors";
import { authenticate } from "../../store/iam/operations";
import { LoginForm } from "../../components/auth";

function Login(props) {
    const navigate = useNavigate();
    const [shouldResetCaptcha, setShouldResetCaptcha] = useState(false);
    const onError = () => {
        setShouldResetCaptcha(true);
    };
    const submitForm = (email, password, recaptchaToken, rememberMe) => {
        setShouldResetCaptcha(false);
        props.authenticate(email, password, recaptchaToken, rememberMe, onError, navigate);
    };
    return (
        <LoginForm
            onSubmit={submitForm}
            isLoading={props.isLoading}
            push={navigate}
            shouldResetCaptcha={shouldResetCaptcha}
        />
    );
}

const mapStateToProps = (state) => ({
    isLoading: userIsLoggingIn(state)
});

export default connect(mapStateToProps, { authenticate })(Login);
